var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1548_3808",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1548_3808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 9.74349C9.19792 9.74349 8.51132 9.45793 7.94021 8.88682C7.36896 8.31557 7.08333 7.62891 7.08333 6.82682C7.08333 6.02474 7.36896 5.33814 7.94021 4.76703C8.51132 4.19578 9.19792 3.91016 10 3.91016C10.8021 3.91016 11.4887 4.19578 12.0598 4.76703C12.631 5.33814 12.9167 6.02474 12.9167 6.82682C12.9167 7.62891 12.631 8.31557 12.0598 8.88682C11.4887 9.45793 10.8021 9.74349 10 9.74349ZM3.75 16.0897V14.237C3.75 13.829 3.86083 13.4511 4.0825 13.1033C4.30417 12.7555 4.60042 12.4881 4.97125 12.3012C5.79486 11.8974 6.62576 11.5946 7.46396 11.3927C8.30215 11.1907 9.1475 11.0897 10 11.0897C10.8525 11.0897 11.6978 11.1907 12.536 11.3927C13.3742 11.5946 14.2051 11.8974 15.0287 12.3012C15.3996 12.4881 15.6958 12.7555 15.9175 13.1033C16.1392 13.4511 16.25 13.829 16.25 14.237V16.0897H3.75ZM5 14.8397H15V14.237C15 14.0683 14.9511 13.912 14.8533 13.7683C14.7556 13.6247 14.6228 13.5074 14.4552 13.4166C13.7372 13.063 13.0051 12.7951 12.259 12.6129C11.5127 12.4308 10.7597 12.3397 10 12.3397C9.24028 12.3397 8.48729 12.4308 7.74104 12.6129C6.99493 12.7951 6.26285 13.063 5.54479 13.4166C5.37715 13.5074 5.24444 13.6247 5.14667 13.7683C5.04889 13.912 5 14.0683 5 14.237V14.8397ZM10 8.49349C10.4583 8.49349 10.8507 8.3303 11.1771 8.00391C11.5035 7.67752 11.6667 7.28516 11.6667 6.82682C11.6667 6.36849 11.5035 5.97613 11.1771 5.64974C10.8507 5.32335 10.4583 5.16016 10 5.16016C9.54167 5.16016 9.14931 5.32335 8.82292 5.64974C8.49653 5.97613 8.33333 6.36849 8.33333 6.82682C8.33333 7.28516 8.49653 7.67752 8.82292 8.00391C9.14931 8.3303 9.54167 8.49349 10 8.49349Z",
    fill: "#226EB7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.1a02abb4534cecec4b931e48e4ee43b9.svg";
export { ForwardRef as ReactComponent };